import produce from 'immer';

import { IMigrationScript } from '../../../utils/prepareWidgetblockMigrationScripts';
import { DataTableConfigBlockState } from '../types';

const addVectorNormalizationToHeadings: IMigrationScript<DataTableConfigBlockState> = (state) => {
    const headings = state.settings.headings.map((heading) => ({
        ...heading,
        vectorNormalization: new Array<string>(heading.databilities.length).fill('magnitude'),
    }));

    return produce(state, (draft) => {
        draft.settings.headings = headings;
    });
};

export default addVectorNormalizationToHeadings;
